import { Chip, Grid, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import {
  SelectFilterComponent,
  SelectFloatingFilterComponent,
  StatusChip,
  StatusType,
  Tabs
} from '@roc/ui';
import { observer } from 'mobx-react';
import { DataGrid } from '@roc/ui';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { useEffect } from 'react';
import { insuranceColumnsDictionary, InsuranceDashboardTab } from '../utils';
import { StyledBadge } from '@roc/feature-loans';
import { BooleanChip } from '@roc/ui';
import { insertIf } from '@roc/feature-utils';

const useStyles = makeStyles(() => ({
  toolbar: {
    backgroundColor: 'white',
    borderRight: '1px solid #dddddd',
    borderLeft: '1px solid #dddddd',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  grid: {
    height: '70vh'
  },
  link: {
    cursor: 'pointer',
    fontWeight: 'bold'
  }
}));

export const InsuranceDashboard = observer(() => {
  const classes = useStyles();
  const { insuranceDashboardStore, userStore } = useRocInternalPortalStore();
  const { insuranceDashoboardGridStore, globalStore } = insuranceDashboardStore;

  const TABS = [
    {
      value: InsuranceDashboardTab.OLD_PIPELINE_UNREAD_TRACKING,
      label: 'Review Latency',
    },
    {
      value: InsuranceDashboardTab.ELMSURE_LATENCY,
      label: 'Elmsure Latency',
    },
    ...insertIf(globalStore.userFeatures && !globalStore.userFeatures?.isInsuranceReviewer, [{
      value: InsuranceDashboardTab.MANUAL_REVIEW_LATENCY,
      label: 'Manual Review Latency',
    }])
  ];

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    insuranceDashoboardGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    insuranceDashoboardGridStore.setFilterModel(filterModel);
  };

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, []);

  useEffect(() => {
    insuranceDashoboardGridStore.resetAndFetchGridData();
  }, [insuranceDashboardStore.selectedTab]);

  const onRowSelected = params => {
    const isSelected = insuranceDashboardStore.setSelectedRecords(
      params?.data?.taskId,
      params?.node.selected
    );
    params.node.setSelected(isSelected);
  };

  const getUnreadMessagesCount = unreadMessages => {
    if (unreadMessages) {
      return unreadMessages > 99 ? '99+' : unreadMessages;
    }
    return undefined;
  };

  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
    loanIdCellRenderer: params => (
      <StyledBadge
        badgeContent={getUnreadMessagesCount(
          params.node.data?.unreadMessages
        )}
      >
        {<Link className={classes.link} onClick={() => window.parent.postMessage({ loanId: params.node.data?.loanId }, '*')}>{params.node.data?.loanId}</Link>}
      </StyledBadge>
    ),
    elmsureCellRenderer: params => <BooleanChip value={params.value} />,
    statusCellRenderer: ({ value }) =>
      value ? (
        <StatusChip label={value} size="small" statusType={StatusType.LOAN} />
      ) : null,
    pendingClosingConditionsCellRenderer: ({ value }) => {
      const backgroundColor = value === 'Pending'
        ? '#d6828a'
        : value === 'Being Reviewed'
          ? '#F5B945'
          : '#89C053';
      return (
        <Chip
          size="small"
          label={value}
          style={{
            backgroundColor: backgroundColor,
            color: 'white',
            fontWeight: 700,
          }}
        />
      );
    },
  };
  return (
    <Layout
      title="Insurance Dashboard"
    >
      <Grid container>
        <Grid item xs={12}>
          <Tabs
            selectedTab={insuranceDashboardStore.selectedTab}
            tabs={TABS}
            onTabChange={(e, i) => insuranceDashboardStore.setSelectedTab(i)}
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            className={classes.grid}
            columns={insuranceDashboardStore.getColumns(insuranceColumnsDictionary[insuranceDashboardStore.selectedTab])}
            rows={insuranceDashoboardGridStore.gridData.data.rows}
            frameworkComponents={frameworkComponents}
            key={insuranceDashboardStore.selectedTab}
            onSortChanged={onSortChanged}
            onFilterChanged={onFilterChanged}
            isLoading={insuranceDashoboardGridStore.isLoading}
            showFilters
            showPagination
            paginationData={insuranceDashoboardGridStore.gridData.meta}
            setPageNumber={insuranceDashoboardGridStore.setPageNumber}
            onRowSelected={onRowSelected}
          />
        </Grid>
      </Grid>
    </Layout>
  );
});
